import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { store } from 'src/common/redux/configure-store';
import { restartPaymentSession } from 'src/devices/payment/pinpad-operations';
import { cancelLine } from 'src/home-page/business-logic/cancel-line-or-item';
import { showVerifyOnlineItemContainer } from 'src/online-items/components/verify-online-item';

export const verifyItem = async (): Promise<void> => {
  const item = store.getState().itemList.ejItems.find(item => item.Selected);
  const onlineItemList = store
    .getState()
    .itemList.ejItems.filter(item => item.OnlineItem?.authorizationExternalId !== undefined);

  if (item?.OnlineItem?.authorizationExternalId && onlineItemList.length > 1) {
    await withSpinner(async () => {
      await restartPaymentSession();
    });
    return showVerifyOnlineItemContainer(onlineItemList);
  }

  return cancelLine();
};
